(function($) {


  $('.js-menu').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('modal-open');
    $('.js-menu, .bk-mobile-nav, .bk-wrapper, .bk-header').toggleClass(
      'active');
  });



  $('.js-category').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('modal-open');
    $('.js-category, .bk-side-filter').toggleClass(
      'active');
  });



  

  $('.js-cart').click(function(e) {
    e.preventDefault();
    $('body').addClass('modal-open');
    $('.bk-cart-side').addClass(
      'active');
  });
  $('.cart-close').click(function(e) {
    e.preventDefault();
    $('body').removeClass('modal-open');
    $('.bk-cart-side').removeClass(
      'active');
  });


   if ($('.owl-banner').length) {
      $('.owl-banner').owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        dots: true,
        nav: false,
        smartSpeed: 450,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        margin: 0,
      });
  };


  $(window).scroll(function() {
    if ($(window).scrollTop() >= 100) {
      $('.bk-header').addClass('fixed-header');
    } else {
      $('.bk-header').removeClass('fixed-header');
    }
  });



      $('[data-productZoom] img').click(function(){
      var image = $(this).attr('data-image');
      $('[data-productZoom] .current').removeClass('current');
      $(this).parent().addClass('current');
      $('#proimage').attr('src', image);
    });




   if ($('.owl-testimonial').length) {
      $('.owl-testimonial').owlCarousel({
        items: 1,
        autoplay: false,
        loop: true,
        dots: true,
        nav: false,
        smartSpeed: 450,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        margin: 30,
      });
  };




   if ($('.owl-prod-details').length) {
      $('.owl-prod-details').owlCarousel({
        items: 1,
        autoplay: false,
        loop: true,
        dots: true,
        nav: false,
        smartSpeed: 450,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        margin: 30,
      });
  };


          if ($('[data-productThumb]').length) {
          $('[data-productThumb]').owlCarousel({
              loop: false,
              margin: 10,
              dots: false,
              nav: true,
              autoplay: false,
              autoplayHoverPause:true,
              mouseDrag: false,
              touchDrag: false,
              responsive: {
                  0: {
                      items: 5
                  },
                  400: {
                      items: 5
                  },
                  768: {
                      items: 5
                  },
                  992: {
                      items: 5
                  },
              }
          });
        };




     if ($('.owl-prod-slider').length) {
      $('.owl-prod-slider').owlCarousel({
              loop: false,
              margin: 10,
              dots: false,
              nav: true,
              autoplay: false,
              autoplayHoverPause:true,
              mouseDrag: false,
              touchDrag: false,
              margin: 30,
              navContainer: $('.js-owl-prod-nav'),
              navText: [`<span class="sr-only">Prew</span>`,`<span class="sr-only">Next</span>`],
              responsive: {
                  0: {
                      items: 1
                  },
                  768: {
                      items: 2
                  },
                  1200: {
                      items: 3
                  },
              }
          });
        };








        if ($('#map').length) {

    google.maps.event.addDomListener(window, 'load', init);

    function init() {

      var bis = {
        info: '<div class="map-info text-center"><strong>Computer Parts<br></strong>\
        1/59 Vicars Street Mitchell ACT<br>\
        2911 Australia<br>\
        <a href="#" target="_blank">View Map</a></div>',
        lat: -35.3331795,
        long: 149.077975,
        title: 'Computer Parts'
      };

      var locations = [
          [bis.info, bis.lat, bis.long, bis.title, 0],
        ];

      var map = new google.maps.Map(document.getElementById('map'), {
        zoom: 14,
        center: new google.maps.LatLng(-35.3331795,149.077975),
        styles: [
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 17
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 18
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dedede"
            },
            {
                "lightness": 21
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "saturation": 36
            },
            {
                "color": "#333333"
            },
            {
                "lightness": 40
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f2f2f2"
            },
            {
                "lightness": 19
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#fefefe"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
        ]
    }
]
,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: false,
        fullscreenControl: false,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
      });

      var infowindow = new google.maps.InfoWindow({});

      var marker, i;

      var icon = {
          // url: theme_url+'/assets/images/marker.png',
          scaledSize: new google.maps.Size(50, 50), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0) // anchor
      };

      for (i = 0; i < locations.length; i++) {
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(locations[i][1], locations[i][2]),
          map: map,
          icon: icon,
          title: locations[i][3]
        });

        google.maps.event.addListener(marker, 'click', (function (marker, i) {
          return function () {
            infowindow.setContent(locations[i][0]);
            infowindow.open(map, marker);
          }
        })(marker, i));
      }
    }
  }




$('#search').click(function() {
  $('.bk-search-form').animate({right: 0}, 50);
  $('.bk-search-popup').show();
  $('#search_query_top').focus();  
  $('.bk-search-bg').click(function() {
    $('.bk-search-popup').hide();
    $('.bk-search-form').animate({right: '-100%'}, 50);
  });
});


  $('.js-aside-nav li button').click(function(e){
    $(this).next().slideToggle();
    $(this).parent().toggleClass('active');
  });






$('.product_choose a').click(function(){
   $(this).parent().parent().parent().parent().find('img').attr('src',$(this).attr('href'));
return false;
});


    $(document).ready(function() {
        $('.bk-mobile-nav .has-sub-menu').prepend('<button type="button"><span class="sr-only">Open Sub Menu</span></button>');
    });

$('.bk-mobile-nav').on('click', 'button', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
        $(this).next().next().slideToggle();
    });









$(document).ready(function() {
  var $slider = $('.product-slider');
  var $progressBar = $('.product-progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
 $('.product-slider').slick({
  infinite: true,
  slidesToShow: 3, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            }
        }

  ]
});  
});



$(document).ready(function() {
  var $slider1 = $('.brand-slider');
  var $progressBar1 = $('.brand-progress-bar');
  var $progressBarLabel1 = $( '.slider__label' );
  
  $slider1.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar1
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel1.text( calc + '% completed' );
  });
  
 $('.brand-slider').slick({
  infinite: true,
  slidesToShow: 6, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
            }
        }

  ]
});  

   var $slider2 = $('.brand-slider-2');
  var $progressBar2 = $('.brand-progress-bar-2');
  var $progressBarLabel2 = $( '.slider__label' );
  
  $slider2.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar2
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel2.text( calc + '% completed' );
  });
  
 $('.brand-slider-2').slick({
  infinite: true,
  slidesToShow: 6, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
            }
        }

  ]
});



   var $slider3 = $('.brand-slider-3');
  var $progressBar3 = $('.brand-progress-bar-3');
  var $progressBarLabel3 = $( '.slider__label' );
  
  $slider3.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar3
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel3.text( calc + '% completed' );
  });
  
 $('.brand-slider-3').slick({
  infinite: true,
  slidesToShow: 6, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
            }
        }

  ]
});


   var $slider4 = $('.brand-slider-4');
  var $progressBar4 = $('.brand-progress-bar-4');
  var $progressBarLabel4 = $( '.slider__label' );
  
  $slider4.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar4
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel4.text( calc + '% completed' );
  });
  
 $('.brand-slider-4').slick({
  infinite: true,
  slidesToShow: 6, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
            }
        }

  ]
});


    var $slider5 = $('.brand-slider-5');
  var $progressBar5 = $('.brand-progress-bar-5');
  var $progressBarLabel5 = $( '.slider__label' );
  
  $slider5.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar5
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel5.text( calc + '% completed' );
  });
  
 $('.brand-slider-5').slick({
  infinite: true,
  slidesToShow: 6, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
            }
        }

  ]
});


     var $slider6 = $('.brand-slider-6');
  var $progressBar6 = $('.brand-progress-bar-6');
  var $progressBarLabel6 = $( '.slider__label' );
  
  $slider6.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar6
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel6.text( calc + '% completed' );
  });
  
 $('.brand-slider-6').slick({
  infinite: true,
  slidesToShow: 6, 
  slidesToScroll: 1,
  arrows: true,
          responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 5,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
            }
        },
        
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2,
            }
        }

  ]
});




});









    $('.js-list').click(function(e) {
    e.preventDefault();
    $('.bk-icon-cat').addClass('list-bk');
    $('.bk-icon-cat').removeClass('grid-bk');
    $('.js-list').addClass('active');
    $('.js-grid').removeClass('active');
  });


   $('.js-grid').click(function(e) {
    e.preventDefault();
    $('.bk-icon-cat').addClass('grid-bk');
    $('.bk-icon-cat').removeClass('list-bk');
    $('.js-list').removeClass('active');
    $('.js-grid').addClass('active');
  });



$(document).ready(function(){
    $("#btn-to-btm").click(function(){
        var element = document.getElementById('welcome');
        $('html, body').animate({
          scrollTop: (getOffset2(element).top-50)
        }, 1000);
    });
});




$('.js-anchor-link').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
  }
});

  
  
$('select').selectpicker();  

  
  
  

})(jQuery);
